<template>
    <form class="module-time-tracker" ref="form">
        <loading-indicator v-if="loading"/>
        <template v-else>
            <form-row label="Mitarbeiter" error-name="employee_id" required>
                <form-select v-model="employee" :options="employees"/>
            </form-row>
            <form-row error-name="spacer">
                <div class="time-tracker-overtime-box">
                    <span :style="{color: remainingColor}">Arbeitszeitkonto: {{remainingOvertime}}</span>
                </div>
            </form-row>
            <form-row label="Typ" error-name="type" required>
                <form-select v-model="type" :options="typeOptions" name="type"/>
            </form-row>
            <form-row label="Woche" error-name="week_start" required>
                <form-input-date type="week" name="week_start" :min="minDate"/>
            </form-row>
            <form-row :label="`Stunden ${0 === type ? 'hinzufügen' : 'abziehen'}`" error-name="overtime_hours" required>
                <form-input type="text" name="overtime_hours" placeholder="Stunden oder S:MM oder SS:MM"/>
            </form-row>
            <form-row label="Begründung" error-name="description">
                <form-textarea class="textarea-vertical" name="description"/>
            </form-row>
        </template>
    </form>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import FormInput from '../../../components/form/FormInput.vue';
    import FormInputDate from '../../../components/form/FormInputDate.vue';
    import FormRow from '../../../components/form/FormRow.vue';
    import FormSelect from '../../../components/form/FormSelect.vue';
    import FormTextarea from '../../../components/form/FormTextarea.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import {formSubmit, getFormData, parseFormData} from '../../../library/form';
    import {popupDefaultCancelButton} from '../../../library/popup';
    import TopMessageHandler from '../../../library/topMessageHandler';
    import {errorHandler} from '../../../utils/portuna';

    @Component({
        name: 'AddOvertimePopup',
        components: {
            LoadingIndicator,
            FormSelect,
            FormTextarea,
            FormInput,
            FormInputDate,
            FormRow
        },
    })
    export default class AddOvertimePopup extends Vue
    {
        readonly $refs: {
            form: HTMLFormElement,
        };

        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) id: number;

        employee: number = 0;

        type: Nullable<number> = null;

        employees: Record<number, string> = {};

        remainingOvertime: string  = '';

        remainingColor: string  = '';

        minDate: string  = '';

        loading: boolean = true;

        @Watch('employee')
        watchEmployee()
        {
            this.fetch();
        }

        @Watch('type')
        watchType()
        {
            this.emitter.emit('setButtons', [
                popupDefaultCancelButton,
                {
                    type: 'success',
                    title: 0 === this.type ? 'Stunden hinzufügen' : 'Stunden abziehen',
                    icon: 0 === this.type ? 'add' : 'remove',
                    cmd: () => this.post(),
                },
            ] as PopupButton[]);
        }

        get typeOptions()
        {
            return [
                {
                    value: 0,
                    label: 'Stunden hinzufügen',
                },
                {
                    value: 1,
                    label: 'Stunden abziehen',
                },
            ];
        }

        created()
        {
            this.employee = this.id;
            this.emitter.emit('setButtons', [popupDefaultCancelButton] as PopupButton[]);
        }

        fetch()
        {
            this.loading = true;
            this.axios.get(`/employee/time-tracker/overtime/add-overtime/employee/${this.employee}`)
            .then(({data: {data: r}}) => {
                this.$store.dispatch('form/setFilter', r.filter);
                this.employees = r.employees;
                this.remainingOvertime = r.remainingOvertime;
                this.remainingColor = r.remainingColor;
                this.minDate = r.minDate;
                this.loading = false;
                this.emitter.emit('lazy-load-focus');
            })
            .catch((err) => {
                errorHandler(err);
                this.emitter.emit('close');
            })
        }

        post()
        {
            let formData = getFormData(this.$refs.form);
            formSubmit(`/employee/time-tracker/overtime/add-overtime/employee/${this.employee}`, parseFormData(formData))
            .then(() => {
                TopMessageHandler.success(`Die Stunden wurden erfolgreich ${0 === this.type ? 'hinzugefügt' : 'abgezogen'}`);
                this.emitter.emit('saved');
                this.emitter.emit('close');
            });
        }
    }
</script>